import { ApiClient } from './client.js'
import { ARTISTS } from './resources.js'

const client = new ApiClient()

export default {
  retrieve (artistId) {
    return client.get(`${ARTISTS}${artistId}/`)
  },

  list () {
    return client.get(`${ARTISTS}`)
  }
}
